module.exports = __webpack_public_path__ + "img/img_ghost_05@3x.70867565.png";